<template>
	<div>
		<div class="columns is-padded-left is-padded-right">
			<div class="column is-full">
				<div class="title has-text-emv offer">
					{{translation.offer}}
				</div>
			</div>
		</div>
		<div class="columns is-multiline is-mobile">
			<div class="column is-full">
				<div class="is-padded-right is-padded-left">
					<template v-for="(value,key) in pricing">
						<pricing
							v-if="key === 'general' || prospectProducts && prospectProducts.includes(key)"
							:pricing="value.pricing"
							:name="translation[key]"
							:selection="selection"
							:selected="value.selected"
							:color-selected="value.color"
							:product="key"
							:translation="translation.price"
						>
						</pricing>
					</template>
				</div>
			</div>
		</div>
		<div class="columns is-hidden-desktop is-padded-left is-padded-right is-hoverable" @click="scrollToForm">
			<div class="column is-full">
				<div class="button is-fullwidth">
					{{translation.fill}}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Pricing from "./pricing.vue";

export default {
	components: {Pricing},
	data: function()
	{
		return 	{
		}
	},
	props : {
		translation : {
			type : Object,
			required : true,
		},
		beneficiaries : {
			type : Number,
			require : false,
			default : 1
		},
		pricing : Object,
		prospectProducts : Array,
		scrollToForm: {
			type : Function,
			require : false,
			default: () => {}
		},
		selection : {
			type : Function,
			require : false,
			default : (product) => {}
		}
	},
	methods : {
	}
}
</script>

<style scoped lang="sass">
	.offer
		font-size: 20px
</style>
